import { Spinner } from "@chakra-ui/react";
import { Checkbox } from "components/RFQ/Checkbox";
import { CustomModal } from "components/RFQ/Modal/CustomModal";
import { Button } from "newui/components/Button";
import { InfoBox } from "newui/components/IconBox";
import { useState } from "react";
import { Company } from "newui/features/Company/types";

interface RemoveSupplierModalProps {
	isLoading?: boolean;
	projectCount: number;
	rfxCount: number;
	showDialog: boolean;
	supplier?: Company;
	onClose: () => void;
	removeSupplierHandler: (companyId: number) => Promise<boolean>;
}

export const RemoveSupplierModal: React.FC<RemoveSupplierModalProps> = ({
	isLoading = false,
	projectCount,
	rfxCount,
	showDialog,
	supplier,
	onClose,
	removeSupplierHandler,
}) => {
	const [checked, setChecked] = useState<boolean>(false);
	const [isDisabled, setIsDisabled] = useState<boolean>(true);

	const onRemoveClicked = () => {
		removeSupplierHandler(supplier?.id ?? 0);
	};

	const dialogProperty = {
		icon: "alert-triangle",
		bgColor: "bg-yellow-200",
		iconColor: "text-utility-brand-700",
		title: `Remove '${supplier?.name}' from this Supplier List`,
		description: (
			<div className="pt-2">
				This supplier list is currently being used by:-
				<br />
				<br />
				<div className="pb-2 text-lg font-semibold">
					{projectCount} RFx Project{projectCount !== 1 ? "s" : ""}
					<br />
					{rfxCount} Draft RFx{rfxCount !== 1 ? "s" : ""}
				</div>
				<InfoBox className="font-semibold">
					If you remove this supplier from the supplier list, they will no
					longer be available to invite to any RFx created within these projects,
					without searching for them again.
					<br />
					<br />
					This does not affect any RFx you have already sent to Suppliers.
				</InfoBox>
			</div>
		),
	};

	const onCheckedChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const isChecked = e.target.checked;
		setChecked(isChecked);
		setIsDisabled(!isChecked);
	};

	const FooterComponent: React.FC = () => (
		<div className="flex w-full justify-between gap-2 text-utility-error-50">
			<Button
				onClick={onClose}
				btntype="base"
				className="!w-full"
				disabled={isLoading}
			>
				Cancel
			</Button>
			<Button
				className="flex !w-full gap-3"
				onClick={onRemoveClicked}
				disabled={isDisabled || isLoading}
				data-testid="submit-button-modal"
			>
				{isLoading && <Spinner />}
				{isLoading ? "Removing ..." : "Remove Supplier"}
			</Button>
		</div>
	);

	return (
		<CustomModal
			onClose={onClose}
			isOpen={showDialog}
			header={dialogProperty}
			footerComponent={<FooterComponent />}
			size="xl"
		>
			<div className="px-1 py-2">
				{
					// @ts-ignore
					<Checkbox
						label={<span>I want to remove this supplier.</span>}
						className="text-sm"
						onChange={onCheckedChange}
						checked={checked}
						testId="addendum-checkbox"
					/>
				}
			</div>
		</CustomModal>
	);
};
